/**
 * DuplicateFlowStage — ein Overlay für Conflict + Merge.
 * Sheets bleiben gemountet und sliden, statt Overlay + Blur neu zu starten.
 */
import React from 'react';
import { createPortal } from 'react-dom';
import './DuplicateFlowStage.css';

export default function DuplicateFlowStage({
  step = 'action',
  lockBackdrop = false,
  onBackdrop,
  action,
  merge,
}) {
  const node = (
    <div
      className="dup-flow-overlay"
      onClick={lockBackdrop ? undefined : onBackdrop}
    >
      <div className="dup-overlay-slot">
        <div
          className={`dup-flow-viewport dup-flow-viewport--dual dup-flow-viewport--${step}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="dup-flow-track">
            <div className="dup-flow-panel">{action}</div>
            <div className="dup-flow-panel">{merge}</div>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return node;
  return createPortal(node, document.body);
}
